import React from "react";
import { t } from "../i18n";
import "./GameSelect.css";
import gamesData from "./gamesData";
import { useNavigate } from "react-router-dom";

const games = Object.entries(gamesData).map(([name, details]) => ({
  name,
  ...details,
}));

const GameSelect = () => {
  const navigate = useNavigate();

  const handleGoToPage = (game) => {
    navigate(`/game/${game.name}`, { state: { game } });
  };

  return (
    <div className="backgroundcolor">
      <div className="game-list-container">
        {games.map((game, index) => (
          <div className="game-info" key={index}>
            <div className="game-image">
              <img src={game.carouselImage} alt={game.name} />
            </div>
            <div className="game-details">
              <h2>{game.name}</h2>
              <h4>{t("genre")}: {game.genre}</h4>
              <p>{game.about}</p>
              <button className="go-to-page" onClick={() => handleGoToPage(game)}>{t("go_to_page")}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GameSelect;
